
export default function WorkflowSection() {
  const steps = [
    {
      number: '01',
      icon: 'ri-send-plane-line',
      title: 'Envio da Amostra',
      description: 'Recebimento e e catalogação'
    },
    {
      number: '02', 
      icon: 'ri-settings-3-line',
      title: 'Escolha do Serviço',
      description: 'Seleção do nível de análise adequado às suas necessidades'
    },
    {
      number: '03',
      icon: 'ri-flask-line',
      title: 'Processamento',
      description: 'Extração de DNA e preparo dos ensaios moleculares'
    },
    {
      number: '04',
      icon: 'ri-microscope-line',
      title: 'Sequenciamento',
      description: 'PCR e sequenciamento Sanger ou NGS conforme protocolo'
    },
    {
      number: '05',
      icon: 'ri-file-chart-line',
      title: 'Análise e Entrega',
      description: 'Análise bioinformática e entrega via sistema Lumus'
    }
  ];

  return (
    <section id="tecnologia" className="py-20 bg-crop-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
            Fluxo de Trabalho
          </h2>
          <p className="text-xl font-gilroy text-crop-dark max-w-3xl mx-auto">
            Processo padronizado em cinco etapas para garantir resultados consistentes e rastreáveis
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center animate-fade-in">
              <div className="relative mb-6">
                <div className="w-20 h-20 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-4 transition-all duration-300 hover:bg-crop-teal/30 hover:scale-105">
                  <i className={`${step.icon} text-3xl text-crop-black`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-crop-black text-crop-white rounded-full flex items-center justify-center text-sm font-gilroy font-bold">
                  {step.number}
                </div>
              </div>
              <h3 className="text-lg font-gilroy font-semibold text-crop-black mb-3">
                {step.title}
              </h3>
              <p className="font-gilroy text-crop-dark text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
